/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const config = require('./src/config');

const analyticsId = process.env.GATSBY_GA_MEASUREMENT_ID || config.googleAnalyticsId;
const shouldTrack = process.env.NODE_ENV === 'production' && Boolean(analyticsId);

exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (!shouldTrack || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  const page_path = `${location.pathname}${location.search}${location.hash}`;
  const previous_path = prevLocation
    ? `${prevLocation.pathname}${prevLocation.search}${prevLocation.hash}`
    : undefined;

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path,
    ...(previous_path ? { page_referrer: previous_path } : {}),
  });
};
